import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';


export const merchantGuard: CanActivateFn = () => {


  const router = inject(Router);


  const token = localStorage.getItem('merchantToken');


  if (token) {

    return true;

  }


  router.navigate(['/merchant/login']);

  return false;

};